import companyPlanningRecordSlice from './companyPlanningRecordSlice'
export default companyPlanningRecordSlice.reducer
